// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-fields.groupfield.textarea-outputs {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  right: 0px;\n}\n.field-ctn.field-area {\n  height: 45px !important;\n  background: transparent !important;\n}\n", ""]);
// Exports
module.exports = exports;
